import tr from '../locales/tr.json';
import en from '../locales/en.json';

const translations = {
  tr,
  en,
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language] || translations.tr;

  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      return key; // Fallback to key if translation not found
    }
  }

  return value;
};

export default getTranslation;
